module.exports = __webpack_public_path__ + "static/media/Grumpig_gaussian2.daf2a764.png";